import * as React from "react"
import T from "../T/T";
import { Link } from "gatsby";
import { LocaleLink } from "../../lib/IntlTools";
import "./styles.scss";

export default function CpaCarousel({ showReward, selectedDisplay, showTitle }) {

    return <div className="design-slider video-bg-banner">
        {!!showReward ? (
            <div className="slide-1 banner-slide no-rewards-banner">
                {selectedDisplay !== 'passport' ?
                    (<>
                        <div className="video-bg">
                            <div className="video-bg-wrapper">
                                <img src="/static/images/cpa/hero1.jpg" alt="" />
                            </div>
                        </div>
                        <div className="concealed-text">
                            <div
                                className="concealed-text-container">
                            </div>
                        </div>
                    </>
                    ) : (
                        <div className="image-bg">
                            <img src="/static/images/cpa/passport-bg-image.jpg" alt="" />
                        </div>
                    )}
            </div>
        ) : (
            <div className="slide-2  banner-slide">
                {selectedDisplay !== 'passport' ?
                    (<>
                        <div className="video-bg">
                            <div className="video-bg-wrapper">
                                <img src="/static/images/cpa/hero1.jpg" alt="" />
                            </div>
                        </div>
                        {!!showTitle && (
                            <div className="concealed-text">
                                <div
                                    className="concealed-text-container">
                                    <h3 className="preWrap"><T>title-qr</T></h3>
                                    <p className=" preWrap"><T>subtitle-qr-1</T></p>
                                </div>
                                <div
                                    className="claim-rewards-button">
                                    <Link to={LocaleLink("/form/")}>
                                        <T>claim-button</T>
                                    </Link>
                                </div>
                            </div>
                        )}
                    </>
                    ) : (
                        <div className="image-bg">
                            <img src="/static/images/cpa/passport-bg-image.jpg" alt="" />
                        </div>
                    )}
            </div>
        )}
    </div>
}
